import deviceDetector from 'helpers/device/deviceDetector'

export default {
  isMobile: isMobile,
  isIOS: isIOS,
  isAndroid: isAndroid
}

function isMobile (deviceType) {
  return deviceType === 'mobile' || deviceType === 'tablet'
}

function isIOS () {
  return deviceDetector.isIos
}

function isAndroid () {
  return deviceDetector.isAndroid
}



// WEBPACK FOOTER //
// ./src/helpers/device/mobileDetector.js